import { useCallback, useEffect, useState } from "react";
import { getStoredUser } from "../api/auth";
import { loadMenuAccessIfAuthenticated } from "../api/rbac";
import { RBAC_CHANGED_EVENT } from "../constants/rbacAccess";
import { enrichMenuWithPermissions, getMenuForUser } from "../constants/menuAccess";

export function useCredoraMenu() {
  const [menu, setMenu] = useState(() => getMenuForUser(getStoredUser(), enrichMenuWithPermissions()));

  const refresh = useCallback(() => {
    setMenu(getMenuForUser(getStoredUser(), enrichMenuWithPermissions()));
  }, []);

  useEffect(() => {
    loadMenuAccessIfAuthenticated().finally(refresh);

    const onStorage = (e) => {
      if (!e.key || e.key === "credora_user") {
        refresh();
      }
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("credora-auth-changed", refresh);
    window.addEventListener(RBAC_CHANGED_EVENT, refresh);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("credora-auth-changed", refresh);
      window.removeEventListener(RBAC_CHANGED_EVENT, refresh);
    };
  }, [refresh]);

  return { menu, refresh };
}
